import { render, staticRenderFns } from "./Chrome.vue?vue&type=template&id=5882f320"
import script from "./Chrome.vue?vue&type=script&lang=js"
export * from "./Chrome.vue?vue&type=script&lang=js"
import style0 from "./Chrome.vue?vue&type=style&index=0&id=5882f320&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports